import _ from 'lodash';
import { FC } from 'react';
import ErrorMesssage from 'common/components/ErrorMesssage';
import { BrokerSpecificComponentsProps } from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';
import UserInput from 'v3/common/components/UserInput';
import PortalToTarget from 'v3/common/components/PortalToTarget';
import Button from 'v3/common/components/Button';

const KotakNeo: FC<BrokerSpecificComponentsProps> = ({ userConfigs, brokerSpecificHandles, switchPage }) => {
  const { validateClientId, updatePartialConfigs, validateTotp, validatePin, changeApiKey, isMobile } =
    brokerSpecificHandles;

  const {
    brokerExtras,
    brokerErrorMessage,
    clientId,
    mobileNumber,
    totp,
    pin,
    isClientValidated,
    isOtpValidated,
    isPinValidated,
    shouldShowApiKey,
    apiKey,
    selectedBrokerConfig,
    isLoading,
    ipAddress,
  } = userConfigs;

  const broker = selectedBrokerConfig?.id;
  const isNewUser = isClientValidated && shouldShowApiKey;
  // const isExistingUser = isClientValidated && !shouldShowApiKey;

  const onSaveAction = () => {
    if (!isClientValidated) {
      //TODO this is hard fix, have to revisit [broker_user_id as mobileNumber]
      return validateClientId({ broker_user_id: clientId });
    }
    if (isClientValidated && !isOtpValidated && !isPinValidated) {
      return validateTotp({ extras: brokerExtras });
    }
    if (isClientValidated && !isPinValidated && isOtpValidated) {
      return validatePin({ extras: brokerExtras }, true);
    }
    return () => {};
  };

  const btnLabel = () => {
    if (!isClientValidated) {
      return 'Validate';
    }
    if (isClientValidated && !isOtpValidated && !isPinValidated) {
      return 'Validate TOTP';
    }

    if (isClientValidated && !isPinValidated && isOtpValidated) {
      return 'Validate MPIN';
    }

    if (isOtpValidated && isPinValidated) {
      return 'Login';
    }
    return '';
  };

  return (
    <form
      id={`${broker}-otp-form`}
      onSubmit={(e) => {
        e.preventDefault();
        onSaveAction();
      }}
    >
      <UserInput
        autoFocus={!isMobile}
        labelValue="Registered Mobile Number"
        id={`${broker}-mobile-number`}
        type="number"
        value={mobileNumber ?? ''}
        isDisabled={isClientValidated}
        onHandleChange={(value) =>
          updatePartialConfigs({ mobileNumber: value === '' ? null : _.toNumber(value) })
        }
      />

      <UserInput
        labelValue="Client ID"
        id={`${broker}-client-id`}
        value={clientId}
        isDisabled={isClientValidated}
        onHandleChange={(value) => updatePartialConfigs({ clientId: value })}
      />

      {shouldShowApiKey && (
        <UserInput
          labelValue="Consumer Key"
          id={`${broker}-consumer-key`}
          value={apiKey}
          isDisabled={isOtpValidated || isPinValidated}
          onHandleChange={(value) => updatePartialConfigs({ apiKey: value })}
        />
      )}

      {isNewUser && (
        <UserInput
          labelValue="Static IP Address"
          id={`${broker}-ip-address`}
          value={ipAddress}
          onHandleChange={(value) => updatePartialConfigs({ ipAddress: value })}
        />
      )}

      {shouldShowApiKey && !!mobileNumber && (
        <button type="button" onClick={() => switchPage()}>
          <i className="fa-regular fa-gear fa-spin" />
          Steps to get consumer API details?
        </button>
      )}

      {isClientValidated && !shouldShowApiKey && (
        <button type="button" onClick={() => changeApiKey()}>
          <i className="fa-regular fa-gear fa-spin" />
          Change in consumer API details?
        </button>
      )}

      {isClientValidated && !isOtpValidated && !isPinValidated && (
        <UserInput
          labelValue="TOTP"
          type="text"
          id={`${broker}-totp`}
          value={totp ?? ''}
          onHandleChange={(value) => updatePartialConfigs({ totp: value })}
        />
      )}

      {isClientValidated && isOtpValidated && !isPinValidated && (
        <UserInput
          labelValue="MPIN"
          type="text"
          id={`${broker}-mpin`}
          value={pin}
          onHandleChange={(value) => updatePartialConfigs({ pin: value })}
        />
      )}

      <ErrorMesssage error={{ message: _.capitalize(_.startCase(brokerErrorMessage)) }} />

      <PortalToTarget targetClassName="login-modal__footer" allowForWeb>
        <Button form={`${broker}-otp-form`} type="submit" isLoading={isLoading}>
          {btnLabel()}
        </Button>
      </PortalToTarget>
    </form>
  );
};

export default KotakNeo;
